module.exports = __webpack_public_path__ + "static/media/afp_iilustracion.83ab7b2d.svg";